<div class="app-input">
  <mat-form-field [formGroup]="group" class="full-width-field">
    <mat-label>{{field.displayName}}</mat-label>
    <input matInput
           [matAutocomplete]="auto"
           [formControl]="cityCtrl"
           (blur)="checkCity()">
    <mat-autocomplete #auto="matAutocomplete">
      @for (city of filteredCities | async; track city) {
        <mat-option [value]="getDisplay(city)" (onSelectionChange)="citySelected($event, city)">
          <span>{{city.name}}</span> |
          <small>{{city.stateName}}</small>
        </mat-option>
      }
    </mat-autocomplete>
    <input [formControlName]="field.name" type="hidden" [value]="field.value">
  </mat-form-field>
</div>
